/* eslint-disable jsx-a11y/no-autofocus */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable react/prop-types */
import React, { useEffect, useState, useRef } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import Typography from '@mui/material/Typography';
import axios from 'lib/axios';
import Comment from '../../assets/static_images/comment.svg';
import Reacts from '../../components/Reacts';
import CreateComment from 'components/comment/CreateComment';
import Modal from '@mui/material/Modal';
import Like from '../../assets/static_images/like.svg';
import Love from '../../assets/static_images/love.svg';
import Haha from '../../assets/static_images/haha.svg';
import Wow from '../../assets/static_images/wow.svg';
import Sad from '../../assets/static_images/sad.svg';
import Angry from '../../assets/static_images/angry.svg';
import Blank from '../../assets/static_images/blank.svg';
import EditPost from 'components/modals/EditPost';
import { Alert } from '@mui/lab';
import DeleteModal from 'components/modals/DeleteModal';
import { Snackbar } from '@mui/material';
import { Box } from '@mui/material';
import YouTubePlayer from 'components/YouTubePlayer';
import ImageViewerModal from 'components/modals/ImageViewerModal';
import ViewReactModal from 'components/modals/ViewReactModal';
import ParentComment from 'components/comment/ParentComment';
import { socket } from '../../socket';
import PostBody from 'components/post/PostBody';
import PostHeader from 'components/post/PostHeader';
import HasPermission from 'utils/HasPermission';
const Post = ({ post, reacts, fetchPosts, setPosts, type = 'non-view', borderNone, commentHideOff = true, postType }) => {
    console.log('test post', post);
    const [contentUrl, setContentUrl] = useState('');
    const [content, setContent] = useState('');
    const [reactOpen, setReactOpen] = useState(false);
    const [reacted, setReacted] = useState(false);
    const [reaction, setReaction] = useState(null);
    const [reactionImg, setReactionImg] = useState(Blank);
    const [commentOpen, setCommentOpen] = useState(false);
    const [reactCount, setReactCount] = useState(parseInt(post.postReactCount));
    const [comments, setComments] = useState([]);
    const [openEditor, setOpenEditor] = useState(false);
    const [user, setUser] = useState(post.user);
    const [limit, setLimit] = useState(5);
    const [offset, setOffset] = useState(0);
    const [fetchedCommentsCount, setFetchedCommentsCount] = useState(0);
    const [openGallery, setOpenGallery] = useState(false);
    const [openSnack, setShowSnack] = useState(false);
    const [openOption, setOpenOption] = useState(false);
    const [snackOptions, setSnackOptions] = useState({ isError: false, message: '' });
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [commentCount, setCommentCount] = useState(post.postCommentCount);
    const [hideComments, setHideComments] = useState(commentHideOff);
    const [openViewReactModal, setOpenViewReactModal] = useState(false);
    const [canEdit, setCanEdit] = useState(false);
    const [canDelete, setCanDelete] = useState(false);
    function handleSnackClose() {
        setShowSnack(false);
    }
    useEffect(() => {
        // keep local user in sync with latest prop
        setUser(post.user);

        const id = post.post_id ? post.post_id.toString() : '';
        const userId = post.user?.user_id;
        if (!id || !userId) return;

        const version = post.updated_at || Date.now();
        const url = `/Uploads/${userId}/Social-Post/${id}/index.html?v=${version}`;
        setContentUrl(`${process.env.REACT_APP_BACKEND_URL}/${url}`);
        axios
            .get(`${url}`)
            .then(({ data }) => {
                setContent(data);
            })
            .catch((err) => console.log(err));

        axios.get(`social-posts/reacted/${post.post_id}`).then(({ data }) => {
            if (data.success) {
                setReacted(data.reacted);
                if (data.react && data.react.react) {
                    setReaction(data.react.react.react_name);
                    if (data.react.react.react_id == 1) {
                        setReactionImg(Like);
                    } else if (data.react.react.react_id == 2) {
                        setReactionImg(Love);
                    } else if (data.react.react.react_id == 3) {
                        setReactionImg(Haha);
                    } else if (data.react.react.react_id == 4) {
                        setReactionImg(Wow);
                    } else if (data.react.react.react_id == 5) {
                        setReactionImg(Sad);
                    } else if (data.react.react.react_id == 6) {
                        setReactionImg(Angry);
                    }
                }
            }
        });
    }, [post.post_id, post.user]);

    const fetchComments = async () => {
        const formData = new FormData();
        formData.append('offset', parseInt(offset));
        formData.append('child_offset', parseInt(0));
        formData.append('limit', parseInt(limit));
        formData.append('child_limit', parseInt(5));
        formData.append('order_by', orderBy);

        await axios.post(`/comments/${post.post_id}`, formData).then(({ data }) => {
            if (data.success) {
                if (offset === 0) {
                    setComments(data.comments);
                } else {
                    setComments((prevComments) => [...prevComments, ...data.comments]);
                }
                setFetchedCommentsCount(data.count);
            }
        });
    };
    const [orderBy, setOrderBy] = useState('created');
    useEffect(() => {
        HasPermission(setCanEdit, 'SocialPost', 'edit', postType == 'leader_voice' ? 'leaders_voice' : 'social_post');
        HasPermission(setCanDelete, 'SocialPost', 'delete', postType == 'leader_voice' ? 'leaders_voice' : 'social_post');
        fetchComments();
    }, [offset]);
    useEffect(() => {
        setComments([]);
        setOffset(0);
        fetchComments();
    }, [orderBy, hideComments]);
    useEffect(() => {
        listen_to_channel();
    }, []);

    function listen_to_channel() {
        socket.on('post_react_added', (post_id) => {
            if (post_id == post.post_id) {
                setReactCount((prev) => prev + 1);
            }
        });
        socket.on('post_react_removed', (post_id) => {
            if (post_id == post.post_id) {
                setReactCount((prev) => prev - 1);
            }
        });
    }
    const [id, setId] = useState(`post-${post.post_id}`);
    const adjustReact = async () => {
        await axios
            .delete('/post-reacts/destroy', { data: { post_id: post.post_id } })
            .then(({ data }) => {
                if (data.success) {
                    setReacted(false);
                    setReactCount((prev) => {
                        // prev = parseInt(prev) - 1;
                        return prev;
                    });
                }
            })
            .catch((err) => console.log(err));
    };

    return (
        <Box
            id={() => id}
            sx={
                type == 'view'
                    ? { paddingX: '0rem', marginY: '1rem', minHeight: '100%', minWidth: '100%' }
                    : {
                          paddingX: '0rem',
                          marginY: '0rem',
                          minHeight: '100%',
                          minWidth: '100%'
                      }
            }
        >
            <Box
                sx={{
                    borderRadius: '10px',
                    padding: '1rem',
                    width: '100%',
                    backgroundColor: '#fff',
                    border: `${!borderNone && '1px solid #1E7C8840'}`
                }}
            >
                <Box>
                    {/* card header  */}
                    <PostHeader
                        post={post}
                        openOption={openOption}
                        setOpenOption={setOpenOption}
                        setOpenEditor={setOpenEditor}
                        setOpenDeleteModal={setOpenDeleteModal}
                        canEdit={canEdit}
                        canDelete={canDelete}
                    />
                    <PostBody post={post} type={type} setOpenGallery={setOpenGallery} />
                    {post.external_video_link && post.external_video_link != '' && (
                        <Box sx={{ position: 'relative', paddingBottom: '1rem' }}>
                            <Box sx={{ height: '400px', width: '100%', borderRadius: '1rem' }}>
                                <YouTubePlayer videoId={post.external_video_link} />
                            </Box>
                        </Box>
                    )}
                    {/* reaction section  */}
                    <Box display="flex" alignItems="center" justifyContent="space-between" marginBottom="0.5rem" sx={{ marginTop: '1rem' }}>
                        <Box display="flex" alignItems="center" gap="1rem">
                            <Box display="flex" alignItems="center">
                                <Box display="flex" alignItems="center" sx={{ position: 'relative' }}>
                                    <Box
                                        className="cursor-pointer"
                                        onMouseEnter={() => setReactOpen(true)}
                                        onMouseLeave={() => setReactOpen(false)}
                                        onClick={() => {
                                            adjustReact();
                                        }}
                                    >
                                        <Box>
                                            {reacted ? (
                                                <Box display="flex" alignItems="center" gap="0.3rem">
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            alignItems: 'center'
                                                        }}
                                                    >
                                                        <img
                                                            src={reactionImg}
                                                            alt="icn"
                                                            style={{
                                                                height: '1rem',
                                                                width: '1rem'
                                                            }}
                                                        />
                                                    </Box>
                                                    <Box>
                                                        <Typography sx={{ opacity: '0.6', fontSize: '0.85rem' }}>{reaction}</Typography>
                                                    </Box>
                                                </Box>
                                            ) : (
                                                <Box display="flex" alignItems="center" gap="0.3rem">
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            alignItems: 'center'
                                                        }}
                                                    >
                                                        <img
                                                            src={Blank}
                                                            alt="icn"
                                                            style={{
                                                                height: '1rem',
                                                                width: '1rem'
                                                            }}
                                                        />
                                                    </Box>
                                                    <Box>
                                                        <Typography sx={{ opacity: '0.6', fontSize: '0.85rem' }}>Like</Typography>
                                                    </Box>
                                                </Box>
                                            )}
                                        </Box>
                                    </Box>
                                    {reactOpen ? (
                                        <Box
                                            sx={{
                                                zIndex: '1024',
                                                position: 'absolute',
                                                top: '-4rem',
                                                left: '1.5rem',
                                                width: '20rem'
                                            }}
                                            onMouseEnter={() => setReactOpen(true)}
                                            onMouseLeave={() => setReactOpen(false)}
                                        >
                                            <Reacts
                                                modelValue={post}
                                                reacts={reacts}
                                                setReactOpen={setReactOpen}
                                                setReacted={setReacted}
                                                setReactCount={setReactCount}
                                                setReactionImg={setReactionImg}
                                                setReaction={setReaction}
                                            />
                                        </Box>
                                    ) : (
                                        <></>
                                    )}
                                </Box>
                            </Box>
                            <Box
                                className="cursor-pointer"
                                onClick={() => {
                                    setCommentOpen(!commentOpen);
                                    setHideComments(false);
                                }}
                                display="flex"
                                alignItems="center"
                                gap="0.3rem"
                            >
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }}
                                >
                                    <img
                                        src={Comment}
                                        alt="icn"
                                        style={{
                                            height: '1rem',
                                            width: '1rem'
                                        }}
                                    />
                                </Box>
                                <Box>
                                    <Typography sx={{ opacity: '0.6', fontSize: '0.85rem' }}>Comment</Typography>
                                </Box>
                            </Box>
                        </Box>
                        <Box
                            className="cursor-pointer"
                            onClick={() => {
                                setCommentOpen(false);
                                setHideComments(!hideComments);
                            }}
                        >
                            <Typography sx={{ opacity: '0.6', fontSize: '0.85rem' }}>{`${commentCount} Comments`}</Typography>
                        </Box>
                    </Box>
                    {/* stats section  */}
                    <Box
                        display="flex"
                        alignItems="center"
                        sx={{ gap: '0.25rem', cursor: 'pointer' }}
                        onClick={() => {
                            setOpenViewReactModal(true);
                        }}
                    >
                        {reacted ? <Typography variant="subtitle1">You</Typography> : <></>}
                        {reactCount > 0 && (
                            <Typography variant="h6">
                                {reacted ? 'and' : ''} {reactCount} {reactCount > 1 ? "other's" : 'other'}
                            </Typography>
                        )}
                        {(reactCount > 0 || reacted) && <Typography variant="subtitle1">reacted on this post</Typography>}
                    </Box>
                    {/* comments section  */}
                    {commentOpen ? (
                        <Grid item sm={12}>
                            <CreateComment setComments={setComments} comments={comments} post={post} setCommentCount={setCommentCount} />
                        </Grid>
                    ) : (
                        <></>
                    )}

                    {comments.length > 0 && !hideComments && (
                        <Grid item xs={12}>
                            <Box>
                                <ParentComment
                                    comments={comments}
                                    setComments={setComments}
                                    setCommentCount={setCommentCount}
                                    setOrderBy={setOrderBy}
                                    orderBy={orderBy}
                                    // type="get-social"
                                    postOwnerId={post.user.user_id}
                                    type="post"
                                />
                            </Box>

                            {fetchedCommentsCount > comments.length && (
                                <Grid container display="flex" justifyContent="start" sm={12}>
                                    <Grid
                                        item
                                        className="cursor-pointer"
                                        onClick={() => {
                                            setOffset((prevOffset) => prevOffset + limit);
                                        }}
                                    >
                                        <Typography variant="subtitle1">Show 5 more comments</Typography>
                                    </Grid>
                                </Grid>
                            )}
                            {comments.length > 0 && fetchedCommentsCount === comments.length && (
                                <Grid container display="flex" justifyContent="start" sm={12}>
                                    <Grid
                                        item
                                        className="cursor-pointer"
                                        onClick={() => {
                                            setHideComments(true);
                                        }}
                                        sx={{
                                            '&:hover': {
                                                opacity: 0.7
                                            }
                                        }}
                                    >
                                        <Typography variant="subtitle1">{`Hide comments`}</Typography>
                                    </Grid>
                                </Grid>
                            )}
                        </Grid>
                    )}
                </Box>
            </Box>
            {openEditor ? (
                <Modal
                    keepMounted
                    open={openEditor}
                    onClose={setOpenEditor}
                    aria-labelledby="keep-mounted-modal-title"
                    aria-describedby="keep-mounted-modal-description"
                >
                    <EditPost
                        setOpenEditor={setOpenEditor}
                        post={post}
                        content={content}
                        user={user}
                        fetchPosts={fetchPosts}
                        setPosts={setPosts}
                        setOpenOption={setOpenOption}
                    />
                </Modal>
            ) : (
                <></>
            )}

            <ImageViewerModal
                open={openGallery}
                onClose={() => setOpenGallery(false)}
                images={post.image || []}
                title={post.content ? post.content.substring(0, 50) + '...' : ''}
            />
            {openDeleteModal ? (
                <Modal
                    keepMounted
                    open={openDeleteModal}
                    onClose={setOpenDeleteModal}
                    aria-labelledby="keep-mounted-modal-title"
                    aria-describedby="keep-mounted-modal-description"
                >
                    <DeleteModal
                        setOpenDeleteModal={setOpenDeleteModal}
                        url={`/social-posts/delete`}
                        id={post.post_id}
                        showSnack={(isError, message) => {
                            setSnackOptions({ isError, message });
                            setShowSnack(true);
                        }}
                        setPosts={setPosts}
                    />
                </Modal>
            ) : (
                <></>
            )}
            <Snackbar
                open={openSnack}
                autoHideDuration={6000}
                onClose={handleSnackClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert onClose={handleSnackClose} severity={snackOptions.isError ? 'error' : 'success'}>
                    {snackOptions.message}
                </Alert>
            </Snackbar>
            {openViewReactModal && (
                <ViewReactModal
                    post={post}
                    type="post"
                    endpoint="/post-reacts/list"
                    setOpenModal={setOpenViewReactModal}
                    openModal={openViewReactModal}
                />
            )}
        </Box>
    );
};

export default Post;
